import { render, staticRenderFns } from "./epidemicNews.vue?vue&type=template&id=a53c0b36&scoped=true&"
import script from "./epidemicNews.vue?vue&type=script&lang=js&"
export * from "./epidemicNews.vue?vue&type=script&lang=js&"
import style0 from "./epidemicNews.vue?vue&type=style&index=0&id=a53c0b36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53c0b36",
  null
  
)

export default component.exports